import { handleValid, Input, InputZipCode } from 'components'
import { TabMyOrganizationItem } from 'interfaces'
import get from 'lodash/get'
import React, { useEffect } from 'react'
import { Path } from 'react-hook-form'
import { configGenaral } from 'utils'
import { PropsComponentsMyOrganization } from './interfaceSlide.type'

export const SlideLocation: React.FC<PropsComponentsMyOrganization> = ({
	pos,
	errors,
	register,
	setValue,
	watch,
	isValid,
	setFieldError,
	name
}): JSX.Element => {
	const sectionErrors = get(errors, `${name}.${pos}.component_value`, {})
	const {
		title: errorTitle,
		address_line: errorAddress,
		zip_code: errorZipCode
	} = sectionErrors
	const nameType = `location-${name}-${pos}`

	const isFieldValid = !(errorTitle || errorAddress || errorZipCode)
	const rules = {
		rule: {
			required: { value: true, message: 'This field is required' }
		}
	}

	useEffect(() => {
		handleValid(nameType, isFieldValid, setFieldError)
		return () => {
			const fields = ['title', 'address_line', 'zip_code'].map(field =>
				watch(
					`${name}.${pos}.component_value.${field}` as Path<{
						tabs: TabMyOrganizationItem[]
					}>
				)
			)

			if (fields.some(value => !value)) {
				handleValid(nameType, false, setFieldError)
			}
		}
	}, [isValid, errorTitle, errorAddress, errorZipCode])

	return (
		<div className="flex flex-col justify-between h-[95%] p-2">
			<div className="flex flex-col gap-6">
				<div className="flex flex-col w-full">
					<Input
						name={`${name}.${pos}.component_value.title`}
						title="Title"
						register={register}
						rules={rules.rule}
						error={errorTitle}
						placeholder="Example: Office"
						borderFull
						limit
						cantLimit={configGenaral.maxTitleLength}
						watchValue={String(
							watch(
								`${name}.${pos}.component_value.title` as Path<{
									tabs: TabMyOrganizationItem[]
								}>
							)
						)}
						setValueInput={setValue}
					/>
				</div>
				<div className="flex flex-col w-full">
					<Input
						name={`${name}.${pos}.component_value.address_line`}
						title="Address Line"
						register={register}
						rules={rules.rule}
						error={errorAddress}
						placeholder="Enter Address"
						borderFull
					/>
				</div>
				<div className="flex flex-col w-full">
					<InputZipCode
						name={`${name}.${pos}.component_value.zip_code`}
						title="Zip/Postal Code"
						register={register}
						rules={rules.rule}
						error={errorZipCode}
						placeholder="Set a Zip/Postal Code"
						borderFull
						setValueInput={setValue}
						maxLength={10}
					/>
				</div>
			</div>
		</div>
	)
}
